<script setup lang="ts">
  import IconArrow from "@/icons/IconArrow.vue";
  import {computed, onMounted, onUnmounted, ref} from "vue";

  const props = defineProps<{
    options: {value: string, label: string, removable: boolean}[];
    modelValue: string;
    placeholder: string;
    className?: {
      [key:string]: boolean,
    };
  }>();
  const emit = defineEmits(['update:modelValue', 'removeItem']);
  const selectOpened = ref(false);
  const filter = ref(false);
  const filterValue = ref("");

  const filteredOptions = computed(() => {
    if(filter.value && filterValue.value) {
      return props.options.filter(i => i.label.toLowerCase().includes(filterValue.value.toLowerCase()) );
    }
    return props.options;
  });

  const selectedValueLabel = computed(() => {
    const value = props.options.find(i => i.value === props.modelValue);
    if(!value) {
      return ' ';
    }
    return value.label;
  })

  const clickOutside = () => {
    selectOpened.value = false
  }

  onMounted(() => {
    document.addEventListener('click', clickOutside);
  });
  onUnmounted(() => {
    document.removeEventListener('click', clickOutside);
  });

  const handleChooseOption = (option: {value: string, label: string, removable: boolean}) => {
    emit('update:modelValue', option.value);
    selectOpened.value = false;
    filter.value = false;
    selectOpened.value = false;
  }
</script>
<template>
  <div class="custom-select" @click.stop :class="{...props.className}" @blur="filter = false" tabindex="-1">
    <div
      style="position: absolute; pointer-events: none; min-height: 50px;"
      :style="{
        opacity: selectOpened ? 0 : 1,
      }"
      :class="{
        'custom-select__input--placeholder': !selectedValueLabel.trim()
      }"
      class="custom-select__input custom-select__input--state input input--no-radius"
      readonly
    >{{selectedValueLabel.trim() ? selectedValueLabel : props.placeholder}}</div>

    <input
      type="text"
      aria-label="State"
      name="state-custom"
      class="custom-select__input custom-select__input--state input input--no-radius"
      :class="{...props.className}"
      :placeholder="props.placeholder"
      autocomplete="off"
      v-model="filterValue"
      @focus="() => {
        selectOpened = true;
        filterValue = '';
      }"
      @keyup="filter = true"
    >

    <div
      class="custom-select__icon"
      @click="() => {
        selectOpened = true;
        filterValue = '';
      }"
    >
      <IconArrow />
    </div>
    <ul class="custom-select__list" :class="{ '_opened': selectOpened }">
      <template v-for="option in filteredOptions" :key="option.value">
        <li class="custom-select__itm custom-select__itm--state" @click="handleChooseOption(option)">
          {{ option.label }}
          <template v-if="option.removable">
            <a href="#" class="custom-select__itm-delete" aria-label="Delete address" @click.stop="emit('removeItem', option.value)"></a>
          </template>
        </li>
      </template>
    </ul>
  </div>
</template>
